import Switch from "common/components/ui/Switch";

export default function BooleanFilter({
  label,
  isChecked,
  onCheckedChange,
}: {
  label: string;
  isChecked: boolean;
  onCheckedChange: (isChecked: boolean) => void;
}) {
  return (
    <div className="mx-2 flex items-center justify-between gap-x-1.5 border-b border-b-black-200 px-2 py-2.5 last:border-none">
      <span className="text-sm-bold">{label}</span>
      <Switch size="sm" checked={isChecked} onCheckedChange={onCheckedChange} />
    </div>
  );
}
